import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from "@angular/router";
import { CommonService } from "../services/common/common.service";
import { AuthService } from "../services/common/auth.service";
import { GlobalConstants } from "../constants/global-constants";

@Injectable({ providedIn: "root" })
export class RouteGuard implements CanActivate {
  constructor(private authService: AuthService, private cs: CommonService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isUserAuthenticated = this.authService.isUserAuthenticated();
    if (isUserAuthenticated) {
      this.cs.routeTo(GlobalConstants.ROUTING.DASHBOARD);
    }
    return true;
  }
}
